module.exports = __webpack_public_path__ + "static/media/attribute_blastradius.436ff005.png";